import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Urls } from '../shared/Urls';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OperatorHelpers } from "../shared//helpers/operator.helpers";
import { QuestionGroup } from "../shared/models/question-group.model";
import { IQuestionGroup } from '../shared/models/interfaces/question.group';
import { IQuestionGroupQuestion } from "../shared/models/interfaces/question-group-question";

@Injectable()
export class QuestionGroupsService {
  constructor(private http: HttpClient) {
  }

  getAllQuestionGroups(): Observable<IQuestionGroup[]> {
    return this.http.get(Urls.getAllQuestionGroups).pipe(
      map(responseData => {
        const data: QuestionGroup[] = [];

        return OperatorHelpers.mapToList(responseData, data);
      })
    );
  }

  getQuestionGroupById(questionGroupId: number): Observable<IQuestionGroup | null> {
    return this.http.get(`${Urls.getQuestionGroupById}${questionGroupId}`).pipe(
      map(responseData => {
        if (responseData) {
          return responseData as QuestionGroup;
        }

        return null;
      })
    );
  }

  createQuestionGroup(questionGroup: IQuestionGroup): Observable<IQuestionGroup | null> {
    return this.http.post(Urls.createQuestionGroup, questionGroup)
      .pipe(
        map(responseData => {
          if (responseData) {
            return responseData as QuestionGroup;
          }

          return null;
        })
      );
  }

  updateQuestionGroup(questionGroup: IQuestionGroup): Observable<IQuestionGroup | null> {
    return this.http.put(Urls.createQuestionGroup, questionGroup)
      .pipe(
        map(responseData => {
          if (responseData) {
            return responseData as QuestionGroup;
          }

          return null;
        })
      );
  }

  deleteQuestionGroup(questionGroupId: number) {
    return this.http.delete(`${Urls.deleteQuestionGroup}${questionGroupId}`);
  }

  createQuestionGroupQuestion(questionGroupQuestion: IQuestionGroupQuestion): Observable<IQuestionGroupQuestion | null> {
    return this.http.post(Urls.addQuestionToQuestionGroup, questionGroupQuestion)
      .pipe(
        map(responseData => {
          if (responseData) {
            return responseData as IQuestionGroupQuestion;
          }

          return null;
        })
      );
  }

  deleteQuestionFromQuestionGroup(questionGroupId: number, questionId: number): Observable<object> {
    return this.http.delete(Urls.deleteQuestionFromQuestionGroup(questionGroupId, questionId));
  }
}
